import EntityInputField from 'vue-forms/components/EntityInputField';
import RoleService from 'app/services/RoleService';

export default {
  mixins: [ EntityInputField ],

  props: {
    service: {
      default: () => RoleService
    },

    idField: {
      default: 'id'
    },

    helpField: {
      default: 'description'
    }
  },

  methods: {
    customLabel(item) {
      return item.name;
    },
  }
};
